module.exports = __webpack_public_path__ + "rs.95f28eccd867726d728d.svg";


//////////////////
// WEBPACK FOOTER
// C:/Angular/projetos/RetycargasOfficialSite/src/assets/vendor/flag-icon-css-master/flags/1x1/rs.svg
// module id = ../../../../../src/assets/vendor/flag-icon-css-master/flags/1x1/rs.svg
// module chunks = styles